import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import Footer from '../components/Footer';

const LegalNoticePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <Button onClick={() => navigate('/')} variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver a la tienda
          </Button>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Aviso Legal</h1>
            <p className="text-sm text-gray-500 mb-8">Última actualización: Febrero 2025</p>

            <div className="prose prose-gray max-w-none space-y-6">
              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">1. Datos Identificativos</h2>
                <p className="text-gray-600">
                  En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa al usuario de los datos del titular:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Denominación:</strong> JRF SPORTSWEAR</li>
                  <li><strong>NIF:</strong> 54372237F</li>
                  <li><strong>Domicilio:</strong> Plaza de la Constitución 15, 29788 Frigiliana (Málaga), España</li>
                  <li><strong>Email:</strong> infojrfsportswear@gmail.com</li>
                  <li><strong>WhatsApp:</strong> +34 611 871 722</li>
                  <li><strong>Actividad:</strong> Venta online de ropa deportiva</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">2. Objeto</h2>
                <p className="text-gray-600">
                  El presente Aviso Legal regula el uso del sitio web www.jrfsportswear.com (en adelante, el "Sitio Web"), del que es titular JRF SPORTSWEAR.
                </p>
                <p className="text-gray-600 mt-2">
                  La navegación por el Sitio Web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">3. Condiciones de Acceso y Uso</h2>
                <p className="text-gray-600">
                  El acceso al Sitio Web es gratuito salvo en lo relativo al coste de la conexión a través de la red de telecomunicaciones suministrada por el proveedor de acceso contratado por el usuario.
                </p>
                <p className="text-gray-600 mt-2">
                  El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que JRF SPORTSWEAR ofrece y a no emplearlos para:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-2">
                  <li>Realizar actividades ilícitas o contrarias a la buena fe y al ordenamiento legal</li>
                  <li>Difundir contenidos de carácter racista, xenófobo, pornográfico, de apología del terrorismo o que atenten contra los derechos humanos</li>
                  <li>Provocar daños en los sistemas físicos y lógicos del Sitio Web o de terceros</li>
                  <li>Introducir virus informáticos o realizar actuaciones susceptibles de alterar, estropear, interrumpir o generar errores en los sistemas</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">4. Propiedad Intelectual e Industrial</h2>
                <p className="text-gray-600">
                  Todos los contenidos del Sitio Web (textos, fotografías, gráficos, imágenes, iconos, tecnología, software, links y demás contenidos audiovisuales o sonoros), así como su diseño gráfico y códigos fuente, son propiedad intelectual de JRF SPORTSWEAR o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación sobre los mismos.
                </p>
                <p className="text-gray-600 mt-2">
                  Las marcas, nombres comerciales o signos distintivos son titularidad de JRF SPORTSWEAR o de terceros, sin que pueda entenderse que el acceso al Sitio Web atribuye ningún derecho sobre los mismos.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">5. Exclusión de Garantías y Responsabilidad</h2>
                <p className="text-gray-600">
                  JRF SPORTSWEAR no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del Sitio Web o la transmisión de virus o programas maliciosos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">6. Legislación Aplicable y Jurisdicción</h2>
                <p className="text-gray-600">
                  Para la resolución de todas las controversias o cuestiones relacionadas con el presente Sitio Web o de las actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente las partes, siendo competentes para la resolución de todos los conflictos derivados o relacionados con su uso los Juzgados y Tribunales de España.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">7. Modificaciones</h2>
                <p className="text-gray-600">
                  JRF SPORTSWEAR se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su Sitio Web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LegalNoticePage;
